<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Contents</div>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="contents.columns" :data="contents.data">
                    <template slot="table-row" v-if="contents.data.length">
                        <tr v-for="(item, index) in contents.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.page_name || `-`}}</td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewContent(item)" v-tooltip.top-center="contents.tooltips.view"><i class="fa fa-eye"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const contentColumns = ['Page Name', 'Operations'];
    export default {
        name: 'Contents',
        components: {
            LTable,
        },
        data() {
        return {
          contents: {
                tooltips: {
                    view: 'View Page Contents'
                },
                columns: [...contentColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchContents () {
            this.$store.dispatch('FETCH_CONTENTS')
                    .then((res) => {
                        this.contents.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewContent(content){
            this.$router.push({ name: 'ViewContent', params: { id: content.dynamic_page_id}})
        }
    },
    created() {
        this.fetchContents();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Contents/Contents.vue